import { Box, Card, CardContent, Chip, Stack, Typography } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { motion } from "framer-motion";
import useResponsive from "../../../Hooks/useResponsive";

const TotalNoOfReports = memo(
  ({
    reportGenerated,
    assessmentTaken,
    totalAdmissionCount,
    totalArpu,
    totalAcr,
    admissionNotConfirmed,
    top,
    navigateFunction,
    totalSfr,
    totalTar,
    revenue,
    saleAmount,
    totalCourseEnrollmentCount
  }) => {
    const [direction, setDirection] = useState("row");
    const mdDown = useResponsive("down", "md");
    useEffect(() => {
      if (mdDown) {
        setDirection("column");
      } else {
        setDirection("row");
      }
    }, [mdDown]);
    return (
      <Box>
        <motion.div
          initial={{ y: -200, x: 0, opacity: 0 }}
          animate={{ y: 0, x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          {/* <Stack direction={mdDown ? "column" : "row"}> */}
            <Stack
              direction={direction}
              sx={{
                p: 3,
                background:
                  "linear-gradient(135deg,rgba(0, 139, 208, 0.79),rgba(160, 37, 194, 0.74))",
                borderRadius: 3,
                gap: 1,
                flexWrap: "wrap", 
              }}
            >
              <Chip
                variant="outlined"
                label={`Assessment Taken : ${assessmentTaken || 0}`}
                sx={{
                  backgroundColor: "white",
                  color: "#a125c2",
                  fontWeight: 500,
                  fontSize: "1rem",
                }}
              />
              <Chip
                variant="outlined"
                label={`Reports Generated : ${reportGenerated || 0}`}
                sx={{
                  backgroundColor: "white",
                  color: "#a125c2",
                  fontWeight: 500,
                  fontSize: "1rem",
                }}
              />
               <Chip
                variant="outlined"
                label={`Course Enrollment : ${totalCourseEnrollmentCount || 0}`}
                sx={{
                  backgroundColor: "white",
                  color: "#a125c2",
                  fontWeight: 500,
                  fontSize: "1rem",
                }}
              />
              <Chip
                variant="outlined"
                label={`Admissions : ${totalAdmissionCount || 0}`}
                sx={{
                  backgroundColor: "white",
                  color: "#a125c2",
                  fontWeight: 500,
                  fontSize: "1rem",
                }}
              />
              <Chip
                variant="outlined"
                label={`ARPU : ${totalArpu || 0}`}
                sx={{
                  backgroundColor: "white",
                  color: "#a125c2",
                  fontWeight: 500,
                  fontSize: "1rem",
                }}
              />
              <Chip
                variant="outlined"
                label={`ACR : ${totalAcr || 0}`}
                sx={{
                  backgroundColor: "white",
                  color: "#a125c2",
                  fontWeight: 500,
                  fontSize: "1rem",
                }}
              />
               <Chip
                variant="outlined"
                label={`TAR : ${totalTar || 0}`}
                sx={{
                  backgroundColor: "white",
                  color: "#a125c2",
                  fontWeight: 500,
                  fontSize: "1rem",
                }}
              />
               <Chip
                variant="outlined"
                label={`SFR : ${totalSfr || 0}`}
                sx={{
                  backgroundColor: "white",
                  color: "#a125c2",
                  fontWeight: 500,
                  fontSize: "1rem",
                }}
              />
              <Chip
                variant="outlined"
                label={`Sale Amount : ${saleAmount || 0}`}
                sx={{
                  backgroundColor: "white",
                  color: "#a125c2",
                  fontWeight: 500,
                  fontSize: "1rem",
                }}
              />
              <Chip
                variant="outlined"
                label={`Revenue : ${revenue || 0}`}
                sx={{
                  backgroundColor: "white",
                  color: "#a125c2",
                  fontWeight: 500,
                  fontSize: "1rem",
                }}
              />
               <Chip
                onClick={() => navigateFunction()}
                sx={{
                  backgroundColor: "white",
                  color: "#a125c2",
                  fontWeight: 500,
                  fontSize: "1rem",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "#a125c2", 
                    color: "white",
                  },
                }}
                variant="outlined"
                label={`Unconfirmed : ${admissionNotConfirmed || 0}`}
              />
              {top && (
                <Chip
                variant="outlined"
                label={`🏆 Top : ${top || ''}`}  
                sx={{
                  background: "linear-gradient(135deg,rgb(105, 37, 194), #008bd0)", // Unique gradient
                  color: "white", 
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  border: "2px solid white",
                  padding: "6px 12px", 
                  borderRadius: "8px", 
                }}
              />
              )}
              

             
            </Stack>
          {/* </Stack> */}
        </motion.div>
      </Box>
    );
  }
);

export default TotalNoOfReports;
